import React from "react";
import Explainer from "../ExplainerModal";

const AuditTrailExplainer = () => {
  return (
    <Explainer
      title="📜 Audit Trail Explainer"
      content={
        <>
          <p>
            The <strong>Audit Trail</strong> records all user activities on the platform, ensuring transparency and accountability. Each action is logged with a timestamp to track key interactions.
          </p>

          <h3 style={{ fontSize: "18px", fontWeight: "bold", marginTop: "15px", color: "#137A08" }}>
            🔍 What’s Tracked?
          </h3>
          <ul>
            <li>🔑 <strong>Logins:</strong> Records when users access the platform.</li>
            <li>📝 <strong>Milestone Responses:</strong> Captures submissions and updates to focal areas.</li>
            <li>📂 <strong>Data Exports:</strong> Logs instances when users download platform data.</li>
            <li>📩 <strong>User Invitations:</strong> Tracks when new users are invited.</li>
            <li>⚙️ <strong>System Changes:</strong> Records modifications to key settings and configurations.</li>
          </ul>

          <h3 style={{ fontSize: "18px", fontWeight: "bold", marginTop: "15px", color: "#137A08" }}>
            📊 Why It Matters?
          </h3>
          <p>
            The Audit Trail enhances platform security, monitors engagement, and provides insights into user interactions, helping administrators maintain data integrity.
          </p>
        </>
      }
    />
  );
};

export default AuditTrailExplainer;
